// module imports
import Link from 'next/link';

export default function AddEventButton({ eventType = 'Event' }) {
  const url = eventType === 'Event' ? '/events/new' : '/presentations/new';
  const buttonText = eventType === 'Event' ? 'Add an upcoming event' : 'Add a presentation';

  return (
    <div className="flex justify-end mb-4">
      <Link href={url}>
        <button className="bg-[#5167b2] text-white font-bold px-8 py-3 rounded-xl shadow hover:bg-[#4158a2] transition cursor-pointer">+ {buttonText}</button>
      </Link>
    </div>
  );
}
